import React from "react";
import { Link } from "react-router-dom";
import { Images } from "../../theme";
import { useTranslation } from "react-i18next";
import "./styles.css";

export default (props) => {
  let categoryData = props.categoryData;
  let newArr = [...categoryData];
  newArr.splice(0, 1);

  const { t } = useTranslation();

  return (
    <div className="container">
      <div
        className="d-flex d-cat justify-content-between align-items-center"
        style={{ marginRight: 10, marginLeft: 10 }}
      >
        <div>
          <div className="row mt-5">
            <div className="col-lg-12 col-6">
              <p className="text-dark MontserratSemiBold explore-head">
                {t("Explore_Item_Categories")}
              </p>
            </div>
            <div className="col-lg-12 text-end col-6 view-btn-main">
              <Link to="" onClick={() => props.setCategoryModal(true)}>
                <button class="view-mobile">{t("View_All")}</button>
              </Link>
            </div>
          </div>

          <p className="text-grey Montserrat text-16 gallery-p">
            {t("Category_Description")}
          </p>
        </div>
        <Link to="" onClick={() => props.setCategoryModal(true)}>
          <button class="view-web mt-4">{t("View_All")}</button>
        </Link>
      </div>
      <div className=" gallery-dis d-flex align-items-center">
        {categoryData.length && (
          <Link
            to="/searchbycategory"
            state={{ data: categoryData[0] }}
            class="overlayoneNew"
          >
            {/* <img
              src={`${props.imageUrl}${categoryData[0]?.imagePath}`}
              alt="image"
              className="gallery-main"
              style={{ height: "100%", width: "100%" }}
            /> */}
            <img
              src={Images.camera1new}
              alt="image"
              className="gallery-main"
              style={{ height: "100%", width: "100%" }}
            />
            <div class="overlayinn">
              <p className="p-cat">{categoryData[0]?.name}</p>
            </div>
          </Link>
        )}

        <div className="d-flex align-items-center flex-wrap hoverContainer">
          {newArr?.map((val, ind) => {
            if (ind < 6)
              return (
                <Link
                  class="overlayone"
                  to="/searchbycategory"
                  state={{ data: val }}
                >
                  <img
                    className="small_imgs"
                    src={`${props.imageUrl}${val?.imagePath}`}
                    alt="image"
                  />
                  <div class="overlayinn">
                    <p className="p-cat">{val?.name}</p>
                  </div>
                </Link>
              );
          })}
        </div>
      </div>
      <div className="py-5 mb-3 mt-5">{assestOnGo(props)}</div>
    </div>
  );
  function assestOnGo(props) {
    return (
      <div
        className="row bg-light access-area"
        style={{ borderRadius: "20px", marginLeft: 4, marginRight: 4 }}
      >
        <div className="col-md-5 col-lg-5 p-4 m-auto">
          <p className="MontserratSemiBold access-text">{t("Access_Go")}</p>
          <p className="text-16 Montserrat access-subtext">
            {t("Access_Go_Description")}
          </p>
        </div>
        <div className="col-md-1 col-lg-1"></div>
        <div className="col-md-6 col-lg-6">
          <img
            className="access-img"
            src={Images.image_7}
            alt="image"
            style={{ width: "100%", marginTop: -88 }}
          />
        </div>
      </div>
    );
  }
};
